export const AUTH_ERROR_CODE = 30002
export const VALIDATION_ERROR_CODE = 30001